<bt-qrcode-design [model]="model" [value]="model.value"></bt-qrcode-design>